/**
 * Enum for runtime environments
 * @readonly
 * @enum {number}
 */
export var RuntimeEnvironment;
(function (RuntimeEnvironment) {
    RuntimeEnvironment[RuntimeEnvironment["Browser"] = 0] = "Browser";
    RuntimeEnvironment[RuntimeEnvironment["NodeJs"] = 1] = "NodeJs";
})(RuntimeEnvironment || (RuntimeEnvironment = {}));
//# sourceMappingURL=RuntimeEnvironment.js.map